module.exports = __webpack_public_path__ + "img/banner_mobile.c0da842f.jpg";